import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/css';
import CheckboxList from './CheckboxList';
import { webkitScrollBarWeight } from '../../utils';
import {
  FilterTitleMobile,
  FilterTitle,
  sectionWrapper,
} from '../Ui';

const wrapper = (params) => css`
  display: flex;
  flex-wrap: wrap;
  ${params?.isMobile && (`
    width: 100%;
    justify-content: start;
    max-height: 233px;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: auto

    scrollbar-color: ${params?.handleColor} ${params?.trackColor};
    scrollbar-width: ${params?.weight};

    ::-webkit-scrollbar {
        width: ${webkitScrollBarWeight[params?.weight]};
        margin-right: 4px;
        right: 4px;
    }
    ::-webkit-scrollbar-track {
        background:  ${params?.trackColor};
        border-radius: 3px;
        box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 1);
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: ${params?.handleColor};
        ${params?.hoverHandleColor && (`
          &:hover {
            background: ${params?.hoverHandleColor};
          }
        `)}
    }
  `)}
`;

const CheckboxWidget = ({
  onChange,
  filter: {
    label: mainLabel = '',
    options,
  },
  themeConfig: {
    multiDropdown,
    scrollBars,
  },
  themeConfig,
  isMobile,
}) => {
  const activeValueTotal = options.reduce((acc, option) => acc + option.activeValue.length, 0);

  return (
    <div className={sectionWrapper({ fitWidth: true, ...multiDropdown })}>
      {mainLabel && (isMobile
        ? (
          <FilterTitleMobile activeValueTotal={activeValueTotal} label={mainLabel} themeConfig={multiDropdown} />
        ) : (
          <FilterTitle label={mainLabel} themeConfig={multiDropdown} />
        )
      )}
      <div className={wrapper({ isMobile, ...scrollBars })}>
        {options?.map((o) => (
          <CheckboxList
            key={o.key}
            isMobile={isMobile}
            themeConfig={themeConfig}
            onChange={onChange}
            filter={o}
          />
        ))}
      </div>
    </div>
  );
};

CheckboxWidget.propTypes = {
  onChange: PropTypes.func,
  filter: PropTypes.object,
  themeConfig: PropTypes.object,
  isMobile: PropTypes.bool,
};

export default CheckboxWidget;
